import global from "@/locales/de-CH/global";
import error403 from "@/locales/de-CH/errors/403";
import error404 from "@/locales/de-CH/errors/404";
import error500 from "@/locales/de-CH/errors/500";
import error503 from "@/locales/de-CH/errors/503";
import error504 from "@/locales/de-CH/errors/504";
import maintenance from "@/locales/de-CH/auth/maintenance";
import toast from "@/locales/de-CH/toast/toast";
import login from "@/locales/de-CH/auth/login";
import onboarding from "@/locales/de-CH/auth/onboarding";
import loginPageSteps from "@/locales/de-CH/loginPageSteps";
import dashboard from "@/locales/de-CH/dashboard/dashboard";
import account from "@/locales/de-CH/account/account";
import mailbox from "@/locales/de-CH/account/mailbox";
import bankstatement from "@/locales/de-CH/account/bankstatement";
import myApps from "@/locales/de-CH/my-apps/myApps";
import about from "@/locales/de-CH/about/about";
import contactService from "@/locales/de-CH/about/contactService";
import salesPromotions from "@/locales/de-CH/sales/promotions";
import brochures from "@/locales/de-CH/sales/brochures";
import shop from "@/locales/de-CH/shop/data";
import priceList from "@/locales/de-CH/shop/priceList";
import staff from "@/locales/de-CH/dashboard/staff";
import promotions from "@/locales/de-CH/promotions";
import points from "@/locales/de-CH/points";
import trainings from "@/locales/de-CH/trainings/trainings";
import vouchers from "@/locales/de-CH/vouchers/vouchers";
import generateReport from "@/locales/de-CH/generate-report/generateReport";
import widgets from "@/locales/de-CH/widgets/widgets";
import wholesaler from "@/locales/de-CH/wholesaler/wholesaler";
import media from "@/locales/de-CH/media/index";
import onlineVisibility from "@/locales/de-CH/sales/onlineVisibility";
import fuelCalculator from "@/locales/de-CH/sales/fuelCalculator";
import product from "@/locales/de-CH/product/index";
import message from "@/locales/de-CH/message/index";
import commitmentLetter from "@/locales/de-CH/account/commitmentLetter";
import multiplicator from "@/locales/de-CH/multiplicator";
import consents from "@/locales/de-CH/consents/consents";
import investment from "@/locales/de-CH/investment/data";
import kickback from "@/locales/de-CH/kickback";

//prettier-ignore
const messages = {
  loginPageSteps: loginPageSteps.messages,
  global: global.messages,
  error403: error403.messages,
  error404: error404.messages,
  error500: error500.messages,
  error503: error503.messages,
  error504: error504.messages,
  maintenance: maintenance.messages,
  toast: toast.messages,
  login: login.messages,
  onboarding: onboarding.messages,
  dashboard: dashboard.messages,
  multiplicator: multiplicator.messages,
  account: account.messages,
  mailbox: mailbox.messages,
  myApps: myApps.messages,
  bankstatement: bankstatement.messages,
  about: about.messages,
  contactService: contactService.messages,
  salesPromotions: salesPromotions.messages,
  shop: shop.messages,
  staff: staff.messages,
  promotions: promotions.messages,
  points: points.messages,
  brochures: brochures.messages,
  trainings: trainings.messages,
  vouchers: vouchers.messages,
  generateReport: generateReport.messages,
  widgets: widgets.messages,
  wholesaler: wholesaler.messages,
  media: media.messages,
  onlineVisibility: onlineVisibility.messages,
  priceList: priceList.messages,
  fuelCalculator: fuelCalculator.messages,
  productInfo: product.messages,
  kickback: kickback.messages,
  message: message.messages,
  commitmentLetter: commitmentLetter.messages,
  consents: consents.messages,
  investment: investment.messages,
  productBrochures: {
    BDriveTitle: "Produkt-Abbildungen",
    BDriveLinkText: "Link zum PRODUKT-ABBILDUNGEN Portal",
  },
}

export default {
  locale: "de-CH",
  messages,
};
